import { useState } from "react";
import { PinIcon } from "@/app/components/system/Icons";
import { LocationModal } from "@/app/components/weather/LocationModal";
import { useWeather } from "@/app/lib/data-context";

interface LocationPillProps {
  dark?: boolean;
}

export function LocationPill({ dark = false }: LocationPillProps) {
  const { location, setLocation } = useWeather();
  const [open, setOpen] = useState(false);

  const label = location?.name ?? "Set location";

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={`inline-flex items-center gap-1.5 py-1.5 pl-2.5 pr-3 rounded-full font-sans text-[12.5px] font-medium cursor-pointer tracking-[0.01em] border backdrop-blur-md transition-[background,transform] duration-150 active:scale-[0.98] ${dark ? "text-paper hover:bg-white/15" : "text-ink hover:bg-white/85"}`}
        style={{
          background: dark ? "oklch(1 0 0 / 0.14)" : "oklch(1 0 0 / 0.65)",
          borderColor: dark ? "oklch(1 0 0 / 0.22)" : "oklch(1 0 0 / 0.55)",
        }}
      >
        <PinIcon size={13} stroke={1.8} />
        <span className="whitespace-nowrap">{label}</span>
      </button>
      {open && (
        <LocationModal
          onClose={() => setOpen(false)}
          onPick={(loc) => { setLocation({ location: loc }); setOpen(false); }}
          current={location}
        />
      )}
    </>
  );
}
